<template>
  <form>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Department <span class="red--text">*</span></v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <v-autocomplete
              v-model="form.departmentId"
              :error-messages="departmentIdErrors"
              required
              outlined
              dense
              flat
              item-text="name"
              item-value="id"
              background-color="white"
              @input="$v.form.departmentId.$touch()"
              @blur="$v.form.departmentId.$touch()"
              @change="onChangeDepartment"
              ref="departmentId"
              :items="departments"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Type <span class="red--text">*</span></v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <v-select
              v-model="form.type"
              :error-messages="typeErrors"
              required
              outlined
              dense
              flat
              background-color="white"
              :items="typeOptions"
              @input="$v.form.type.$touch()"
              @blur="$v.form.type.$touch()"
              ref="type"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
            <v-subheader>Employees <span class="red--text">*</span></v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="4" lg="4" class="py-0">
            <v-autocomplete
              v-model="selectedEmployees"
              :error-messages="employeesErrors"
              outlined
              dense
              flat
              multiple
              chips
              small-chips
              deletable-chips
              item-text="name"
              item-value="id"
              return-object
              background-color="white"
              :items="employees"
              @input="$v.selectedEmployees.$touch()"
              @blur="$v.selectedEmployees.$touch()"
              ref="selectedEmployees"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0" cols="12">
        <v-btn
          v-if="$rbac.can('setting-kasbon-approval.create')"
          class="mr-4"
          @click="submit"
          color="primary"
        >
          submit
        </v-btn>
        <v-btn @click="clear">
          clear
        </v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],

  validations: {
    form: {
      departmentId: { required },
      type: { required },
    },
    selectedEmployees: { required, minLength: minLength(1) },
  },

  data: () => ({
    departments: [],
    selectedEmployees: [],
    typeOptions: ["Cash Advance", "Settlement", "Payment"],
    form: {
      departmentId: null,
      departmentName: "",
      type: null,
    },
  }),

  computed: {
    departmentIdErrors() {
      const errors = [];
      if (!this.$v.form.departmentId.$dirty) return errors;
      !this.$v.form.departmentId.required && errors.push("Department is required");
      return errors;
    },
    typeErrors() {
      const errors = [];
      if (!this.$v.form.type.$dirty) return errors;
      !this.$v.form.type.required && errors.push("Type is required");
      return errors;
    },
    employeesErrors() {
      const errors = [];
      if (!this.$v.selectedEmployees.$dirty) return errors;
      !this.$v.selectedEmployees.required && errors.push("At least one employee is required");
      !this.$v.selectedEmployees.minLength && errors.push("At least one employee is required");
      return errors;
    },
    ...mapState("external", ["employees"]),
  },

  methods: {
    onChangeDepartment(val) {
      if (val) {
        const department = this.departments.find(d => d.id === val);
        if (department) {
          this.form.departmentName = department.name;
        }
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      const body = {
        departmentId: this.form.departmentId,
        departmentName: this.form.departmentName,
        type: this.form.type,
        employees: this.selectedEmployees.map(emp => ({
          employeeId: emp.id,
          employeeName: emp.name,
        })),
      };
      this.$store.dispatch("kasbonApproval/create", body);
    },
    clear() {
      this.$v.$reset();
      this.form = {
        departmentId: null,
        departmentName: "",
        type: null,
      };
      this.selectedEmployees = [];
    },
  },

  mounted() {
    this.$store.dispatch("external/getEmployees").then(() => {
      const deptMap = {};
      this.employees.forEach(emp => {
        if (emp.department && !deptMap[emp.department.id]) {
          deptMap[emp.department.id] = emp.department;
        }
      });
      this.departments = Object.values(deptMap);
    });
  },
};
</script>

<style></style>
